<template>
<div class="container">
    <div class="row">
        <div class="col-lg-2">
        </div>
    <!--
        <div class="col-lg-4">
            <div class="card mb-5 mb-lg-0">
                <div class="card-body">
                    <h5 class="card-title text-muted text-uppercase text-center">Mieterbüro Flensburg</h5>
                    <hr>
                    <ul class="fa-ul">
                        <li><span class="fa-li"><i class="fas fa-times"></i></span>Breedlandweg 16</li>
                        <li><span class="fa-li"><i class="fas fa-times"></i></span>24944 Flensburg</li>
                        <li><span class="fa-li"><i class="fas fa-times"></i></span><strong>Fon: 0461 / 31 34 605</strong></li>
                        <li><span class="fa-li"><i class="fas fa-times"></i></span>Fax: 0461 / 31 34 838</li>
                    </ul>
                    <hr>
                    <h6 class="card-price text-center">Öffnungszeiten</h6>
                    <hr>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isMonday ? 'bold': '' }">Montag</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isTuesday ? 'bold': '' }">Dienstag</div>
                        <div class="col-sm-6 text-right">10:00 - 12:00 Uhr</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isWednesday ? 'bold': '' }">Mittwoch</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isThursday ? 'bold': '' }">Donnerstag</div>
                        <div class="col-sm-6 text-right">15:00 - 17:00 Uhr</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isFriday ? 'bold': '' }">Freitag</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <hr>
                    <div class="row" style="height: 150px;">
                        <l-map :zoom="zoom" :center="centerBLW">
                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                            <l-marker :lat-lng="markerBLW"></l-marker>
                        </l-map>
                    </div>
                </div>
            </div>
        </div>
        -->
        <div class="col-lg-4">
            <div class="card mb-5 mb-lg-0">
                <div class="card-body">
                    <h5 class="card-title text-muted text-uppercase text-center">Mieterbüro Rendsburg</h5>
                    <hr>
                    <ul class="fa-ul">
                        <li><span class="fa-li"><i class="fas fa-check"></i></span>Vierzonstraße 22</li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span>24768 Rendsburg</li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>Fon: 04331 / 45 98 309</strong></li>
                        <li><span class="fa-li"><i class="fas fa-times"></i></span>Fax: 04331 / 45 98 310</li>
                    </ul>
                    <hr>
                    <h6 class="card-price text-center">Öffnungszeiten</h6>
                    <hr>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isMonday ? 'bold': '' }">Montag</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isTuesday ? 'bold': '' }">Dienstag</div>
                        <div class="col-sm-6 text-right">12:00 - 16:00 Uhr</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isWednesday ? 'bold': '' }">Mittwoch</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isThursday ? 'bold': '' }">Donnerstag</div>
                        <div class="col-sm-6 text-right">10:00 - 12:00 Uhr</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isFriday ? 'bold': '' }">Freitag</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <hr>
<!--                    <div class="row" style="height: 150px;">
                        <l-map :zoom="zoom" :center="centerVS">
                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                            <l-marker :lat-lng="markerVS"></l-marker>
                        </l-map>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title text-muted text-uppercase text-center">Mieterbüro Schwerin</h5>
                    <hr>
                    <ul class="fa-ul">
                        <li><span class="fa-li"><i class="fas fa-check"></i></span>Mecklenburgstraße 34</li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span>19053 Schwerin</li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>Fon: 0385 / 59 23 186</strong></li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span>Fax: 0385 / 59 23 188</li>
                    </ul>
                    <hr>
                    <h6 class="card-price text-center">Öffnungszeiten</h6>
                    <hr>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isMonday ? 'bold': '' }">Montag</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isTuesday ? 'bold': '' }">Dienstag</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isWednesday ? 'bold': '' }">Mittwoch</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isThursday ? 'bold': '' }">Donnerstag</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 text-left" :style="{ 'font-weight' : isFriday ? 'bold': '' }">Freitag</div>
                        <div class="col-sm-6 text-right">nach Vereinbarung</div>
                    </div>
                    <hr>
<!--                    <div class="row" style="height: 150px;">
                        <l-map :zoom="zoom" :center="centerMS">
                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                            <l-marker :lat-lng="markerMS"></l-marker>
                        </l-map>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// import Vue from 'vue'
import 'leaflet/dist/leaflet.css'
//import { L, Icon } from 'leaflet'
//import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
//Vue.component('l-map', LMap);
//Vue.component('l-tile-layer', LTileLayer);
//Vue.component('l-marker', LMarker);
//delete Icon.Default.prototype._getIconUrl;

//Icon.Default.mergeOptions({
//    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//    iconUrl: require('leaflet/dist/images/marker-icon.png'),
//    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
//});

import moment from "moment";

export default {
//    components: {
//        LMap,
//        LTileLayer,
//        LMarker
//    },
    mounted() {
        this.$ga.screenview('bueros')
    },
    data() {
        return {
            isMonday: moment().isoWeekday() == 1,
            isTuesday: moment().isoWeekday() == 2,
            isWednesday: moment().isoWeekday() == 3,
            isThursday: moment().isoWeekday() == 4,
            isFriday: moment().isoWeekday() == 5,
            // zoom: 16,
            // centerBLW: L.latLng(54.801320, 9.478610),
            // centerVS: L.latLng(54.302130, 9.696160),
            // centerMS: L.latLng(53.627420, 11.412480),
            // url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            // attribution: '',
            // markerBLW: L.latLng(54.801320, 9.478610),
            // markerVS: L.latLng(54.302130, 9.696160),
            // markerMS: L.latLng(53.627420, 11.412480),
        }
    }
}
</script>

<style>
ul {
    list-style-type: none;
}

.row {
    margin-top: 10px;
}
</style>
